import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { Layout } from 'features/common/components/Layout';
import { ServicesDataList } from 'features/salesOrder/components/ServicesDataList';

export const SaleOrderServicesListPage = (): JSX.Element => {
	return (
		<Layout>
			<Container component="main" maxWidth={false} sx={{ py: 4, px: { xs: 2, md: 4 }, maxWidth: '100%' }}>
				<Box sx={{ mb: 3 }}>
					<Typography variant="h5" sx={{ fontWeight: 600 }}>
						Servicios de órdenes de venta
					</Typography>
					<Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
						Listado global de servicios con filtros avanzados y acceso directo a la SaleOrder
					</Typography>
				</Box>
				<ServicesDataList />
			</Container>
		</Layout>
	);
};
